<template lang="pug">
  .work-profession
    .field.is-horizontal.min-height(v-tooltip="{content: tooltip, show: showTooltip}")
      label.label.font.is-pulled-left {{ gettext('Profession') }}
      .field-body
    .field.is-horizontal.min-height(v-if="!seasonal")
      label.label.name
        span.radio-wrap.left(v-show="getUser.only_cv_has_profession !== true")
          input.is-checkradio.custom-checkbox-box#no-profession(
          type="checkbox"
          name="no-profession"
          v-model="form.noProfession"
          :disabled="getUser.only_cv_has_profession === false"
          )
          label(for="no-profession") {{ gettext('I do not have profession yet') }}
      .field-body
    transition(tag="div" name="fade")
      .prof-wrapper(v-if="!form.noProfession")
        .field.is-horizontal
          label.label.name {{ gettext('Profession branch')+'*' }}
          .field-body(@click="validateData('profession_company_type')")
            ajax-dropdown.wide(
            v-model="form.profession_company_type"
            :labelText="gettext('Choose the company type')"
            :class="{'is-danger': $v.form.profession_company_type.$error, 'is-empty': !form.profession_company_type}"
            :itemName ="'name'"
            :returnItem ="'id'"
            :filter="getUser.only_cv_profession_company_types"
            :action="{method: 'receiveCompanyTypes', params:{lang: getLanguage, country: null, filters: seasonal ? ['for_seasonal_work']: []}}"
            @updated="dropdownSelected('profession_company_sector', 'profession_company_sector')"
            )

        .field.is-horizontal
          label.label.name {{ gettext('Profession sector')}}{{seasonal ? '' : '*'}}
          .field-body(@click="validateData('profession_company_sector')")
            ajax-dropdown.wide(
            v-model="form.profession_company_sector"
            :labelText="gettext('Choose the company sector')"
            :itemName ="'name'"
            :returnItem ="'id'"
            :action="{method: 'receiveCompanySectors', params:{lang: getLanguage, type: form.profession_company_type}}"
            :class="{'is-danger': $v.form.profession_company_sector.$error, 'is-empty': !form.profession_company_sector}"
            :disabled="!form.profession_company_type"
            @updated="dropdownSelected('profession', 'profession')"
            @selected="setProfession()"
            )

        .field.is-horizontal
          label.label.name {{ gettext('Profession')}}{{seasonal ? '' : '*'}}
          .field-body(@click="validateData('profession_company_sector')")
            ajax-dropdown.wide(
            v-model="form.profession"
            :labelText="gettext('Choose the profession')"
            :itemName ="'name'"
            :returnItem ="'id'"
            :autoLoad="true"
            ref="profession"
            :class="{'is-danger': $v.form.profession.$error, 'is-empty': !form.profession}"
            :action="{method: 'receiveWorkProfessions', params:{lang: getLanguage, sector: form.profession_company_sector}}"
            :disabled="!form.profession_company_sector"
            )
</template>
<script>
import Vue from 'vue'
import mixin from '@/mixins'
import {gettext} from '@/services/TranslateHandler'
import {mapGetters} from 'vuex'
import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import AjaxDropdown from '@/components/ajax-dropdown'

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
}).use(Vuelidate)

export default {
  name: 'WorkProfession',
  mixins: [
    mixin
  ],
  components: {
    AjaxDropdown
  },
  data () {
    return {
      showTooltip: false,
      form: {
        profession_company_type: '',
        profession_company_sector: '',
        profession: '',
        noProfession: false
      }
    }
  },
  validations: {
    form: {
      profession_company_type: {required},
      profession_company_sector: {
        required: function (data, current) {
          return !current.seasonal
        }
      },
      profession: {
        required: function (data, current) {
          return !current.seasonal
        }
      }
    }
  },
  props: {
    value: {
      default: () => {
        return {}
      }
    },
    tooltip: {
      default: ''
    },
    seasonal: {
      default: false
    },
    ready: {
      default: false
    }
  },
  methods: {
    gettext: gettext,
    clear (...fields) {
      for (let item of fields) {
        this.$props['value'][item] = ''
      }
    },
    setProfession () {
      if (this.$route.params.id) return
      this.$nextTick(() => {
        this.$refs.profession.receiveDataFromOutside()
      })
    },
    dropdownSelected (watch, ...clear) {
      if (this.value[watch]) {
        this.clear(...clear)
      }
    },
    validateData (attr) {
      if (attr) {
        this.$v.form[attr].$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }
        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      } else {
        this.$v.$touch()
        if (this.$v.$anyError) {
          this.showTooltip = true
        }
        setTimeout(() => {
          this.showTooltip = false
        }, 5000)
      }
    },
    setOnlyCvParams () {
      if (this.$route.params.id) return
      if (this.getUser.only_cv_has_profession === false) {
        this.form.noProfession = true
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    formIsValid: function () {
      return !this.$v.$invalid
    }
  },
  watch: {
    form: {
      deep: true,
      handler (val) {
        this.$emit('input', val)
      }
    },
    value (val) {
      this.form = val
    },
    seasonal (val) {
      if (val) {
        this.form.noProfession = false
      }
    },
    ready () {
      if (this.ready) {
        this.setOnlyCvParams()
      }
    }
  },
  mounted () {
    if (this.ready) {
      this.setOnlyCvParams()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile/cvs/cv/parts/work-profession/index.vue